import { ref } from 'vue'
import type { Anchor } from 'vuetify'

interface SnackbarOptions {
  text: string;
  color?: string;
  timeout?: number;
  position?: Anchor;
}

const snackbarVisible = ref(false)
const snackbarText = ref('')
const snackbarColor = ref('')
const snackbarTimeout = ref(3000)
const snackbarPosition = ref<Anchor>('bottom left')

export function useSnackbar () {
  const showSnackbar = (options: SnackbarOptions) => {
    snackbarText.value = options.text
    snackbarColor.value = options.color || 'primary'
    snackbarTimeout.value = options.timeout || 3000
    snackbarPosition.value = options.position || 'bottom left'
    snackbarVisible.value = true
  }

  const hideSnackbar = () => {
    snackbarVisible.value = false
  }

  return {
    snackbarVisible,
    snackbarText,
    snackbarColor,
    snackbarTimeout,
    snackbarPosition,
    showSnackbar,
    hideSnackbar,
  }
}
